// 图片上传到 Pinata/IPFS
export async function uploadImageToIPFS(file) {
  const API_URL = 'https://pinata-rotator-worker.torweb321.workers.dev/upload-image';
  const formData = new FormData();
  formData.append('file', file);
  const res = await fetch(API_URL, { method: 'POST', body: formData });
  if (!res.ok) throw new Error('图片上传失败');
  const data = await res.json();
  return data.IpfsHash ? `https://ipfs.io/ipfs/${data.IpfsHash}` : '';
}
